import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem, imageClassName } from '@archipro-design/aria';

export const FloatingIcon: StyleRule = ({ theme }) => ({
    transform: 'translateY(-50%)',
    background: theme.siteVariables.colors.primitive.white,
    width: pxToRem(40),
    height: pxToRem(40),
    padding: pxToRem(8),
    cursor: 'pointer',
});

export const FloatingTooltip: StyleRule = ({ theme }) => ({
    fontSize: theme.siteVariables.fontSizes.caption06,
    textAlign: 'center',
    padding: pxArrayToRem([6, 8]),
    zIndex: theme.siteVariables.zIndexes.menuItem + 1,
    '& > div:first-of-type': {
        marginTop: pxToRem(-2),
    },
    [`& .${imageClassName}`]: {
        background: theme.siteVariables.colors.primitive.white,
    },
});

export const fabAnimation = {
    open: {
        transform: `translateX(${pxToRem(-40)})`,
        transition: {
            duration: 0.2,
        },
    },
    closed: {
        transform: `translateX(${pxToRem(0)})`,
        transition: {
            duration: 0.2,
            delay: 0.2,
        },
    },
};
